<template>
  <b-form-group class="form-group-checkbox" :style="`margin-bottom:${bottom}px`">
    <b-form-checkbox
      :id="'checkbox__' + formGroupId"
      v-model="text"
      :name="'checkbox__' + formGroupId"
      :required="required"
      class="checkbox"
      :disabled="disabled || viewMode"
      :style="`padding-left:${left}px`"
      @change="updateValue"
    >
      <span :class="{ 'required-color': required && !text }">
        {{ placeholder | i18n }}
        <span v-if="required">*</span>
      </span>
    </b-form-checkbox>
    <b-form-text v-if="bottomText">
      {{ bottomText }}
    </b-form-text>
  </b-form-group>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    bottomText: {
      type: String,
      default: '',
    },
    formGroupId: {
      type: String,
      default: null,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    left: {
      type: Number,
      default: 0,
    },
    bottom: {
      type: Number,
      default: 35,
    },
    input: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      text: null,
    };
  },
  watch: {
    value(newVal) {
      this.text = newVal;
    },
  },
  mounted() {
    this.text = this.value;
  },
  methods: {
    updateValue(value) {
      if (this.input) {
        this.input(value);
      }
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss">
.checkbox {
  display: flex;
  align-items: center;
  label {
    margin-bottom: 0 !important;
    padding-left: 26px;
    display: flex;
    align-items: center;
  }
  &.custom-checkbox .custom-control-label::before {
    width: 16px;
    height: 16px;
    border: 1px solid #646a87;
    border-radius: 4px;
    margin-top: 2px;
  }
  &.custom-control > .custom-control-input:checked ~ .custom-control-label::before {
    border: 1px solid #2260ff;
    background: inherit !important;
  }
  &.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
    top: 4px;
    left: 2px;
    border-radius: 2px;
  }
  &.custom-checkbox .custom-control-label span {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }
}

.required-color {
  color: #ed3232;
}
</style>
